import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { TradesResponse } from "../api/types";

/**
 * История наших сделок из журнала (веха M6).
 *
 * TanStack Query, а не стор ленты, и это разные источники по построению. Лента
 * живёт сокетом и держит скользящее окно на пару минут; здесь спрашивают
 * Postgres, который переживает и вкладку, и рестарт трейдера. Сливать их
 * нечего: вопросы «что происходит сейчас» и «что было утром» — разные.
 */
export interface TradesQuery {
  market?: string | undefined;
  wallet?: string | undefined;
  sinceHours?: number | undefined;
}

export function tradesKey(q: TradesQuery) {
  return ["trades", q.market ?? "", q.wallet ?? "", q.sinceHours ?? 0] as const;
}

/**
 * Как часто перечитывать.
 *
 * Полминуты: история пополняется ровно тогда, когда мы торгуем, а свежую сделку
 * оператор всё равно видит в ленте секундой позже филла. Опрос чаще возвращал
 * бы ту же страницу.
 */
const POLL_MS = 30_000;

export function useTrades(q: TradesQuery) {
  return useQuery<TradesResponse>({
    queryKey: tradesKey(q),
    queryFn: () =>
      api.trades({
        ...(q.market ? { market: q.market } : {}),
        ...(q.wallet ? { wallet: q.wallet } : {}),
        ...(q.sinceHours ? { since_hours: q.sinceHours } : {}),
      }),
    refetchInterval: POLL_MS,
    refetchIntervalInBackground: false,
  });
}
